import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import "./App.css";
import NavBar from "./components/NavBar/NavBar";
import HomePage from "./Pages/Home/Home";
import "./styles/globals.css";
import Footer from "./components/Footer/Footer";
import Products from "./Pages/Products/Products";
import ProductPage from "./Pages/Product/ProductPage";
import { ProductsProvider } from "./context/ProductsContext";
import Profile from "./Pages/Profile/Profile";
import SearchBox from "./components/SearchBox/SearchBox";
import { useEffect, useState } from "react";
import { GeneralStyleProvider } from "./context/GeneralStyleContext";
import SimpleBtn from "./components/Button/SimpleBtn";
import { handleCall } from "./utils/callHelper";

function App() {
  const [searchState, setSearchState] = useState(false);
  const handleSearch = () => setSearchState(!searchState);
  const [navExpand, setNavExpand] = useState(true);

  return (
    <Router>
      <div className="App">
        <GeneralStyleProvider
          value={{ navExpand: navExpand, setNavExpand: setNavExpand }}>
          <NavBar handleSearch={handleSearch} searchState={searchState} />
          <SimpleBtn className="callUsBtn" onClick={handleCall}>
            تماس با ما
          </SimpleBtn>
          <ProductsProvider>
            <div className="pages">
              <Routes>
                <Route path="/Profile" element={<Profile />} />
                <Route path="/Products/:category?" element={<Products />} />
                <Route
                  path="/Product/:productName?"
                  element={<ProductPage />}
                />
                <Route path="/" element={<HomePage />} />
                {/* <Route path="/Search" element={<Search />} /> */}
              </Routes>
            </div>

            <Footer />
          </ProductsProvider>
        </GeneralStyleProvider>
      </div>
    </Router>
  );
}

export default App;
